import {REMOVE_IMAGE, START, SUCCESS, FAIL} from "../constants/action-types";
import {API_IMAGES} from "../constants/api";

export const removePicture = ({id}) => (dispatch, getState) => {
  dispatch({
    type: REMOVE_IMAGE + START
  });
  fetch(`${API_IMAGES}/${id}`, {
    method: `delete`,
    headers: {
      "Accept": `application/json`,
      "Content-Type": `application/json`
    },
    body: JSON.stringify({
      /* eslint-disable camelcase */
      authenticity_token: getState().authenticityToken
      /* eslint-enable camelcase */
    }),
    credentials: `same-origin`
  })
    .then((res) => {
      if (res.status >= 400) {
        throw new Error(`Error`);
      }
      dispatch({type: REMOVE_IMAGE + SUCCESS, payload: {id}});
    })
    .catch((error) => {
      dispatch({type: REMOVE_IMAGE + FAIL, error});
    });
};
